module.exports = __webpack_public_path__ + "img/rhombus-orange.e2168e0b.svg";